module.exports = __webpack_public_path__ + "static/media/carroussel_12.dc4d4cf3.jpg";